<div class="content-container">
  <div class="content">
    <div class="mb-4 content-header">
      <mwp-text-translate text="MEMBER SEARCH" jsonKey="memberSearch" />
    </div>
    <div class="mb-4">
      <mwp-companies-dropdown [form]="companySearchForm" [nameForControl]="'companyName'" [idForControl]="'companyID'" (emitSelectedCompany)="searchByCompany($event)" />
    </div>
    <form [formGroup]="memberSearchForm">
      <div class="mb-4">
        <mwp-input [form]="memberSearchForm" labelName="Last Name" nameForControl="lastName" />
      </div>
      <div class="mb-4">
        <mwp-input [form]="memberSearchForm" labelName="First Name" nameForControl="firstName" />
      </div>
      <div class="row justify-content-between mb-4">
        <div class="col-5">
          <mwp-input [form]="memberSearchForm" labelName="ERID" nameForControl="erid" type="number" [maskType]="maskType.numericValues" />
        </div>
        <div class="col-5">
          <mwp-input [form]="memberSearchForm" labelName="System ID" nameForControl="systemId" type="number" [maskType]="maskType.numericValues" />
        </div>
      </div>
      @if (!isTestMemberSearch) {
      <div class="row justify-content-between mb-4">
        <div class="col-5">
          <mwp-input [form]="memberSearchForm" labelName="SSN" nameForControl="ssn" [maskType]="maskType.social" />
        </div>
        <div class="col-5">
          <mwp-input [form]="memberSearchForm" labelName="Last 4 SSN" nameForControl="last4SSN" [maxLength]=4 [maskType]="maskType.numericValues"/>
        </div>
      </div>
      <div>
        <button class="mwp-button col-12" [disabled]="!memberSearchForm.valid" (click)="search()">
          <mwp-text-translate text="SEARCH" jsonKey="search" />
        </button>
      </div>
      }
      @if (isTestMemberSearch) {
      <div>
        <button class="mwp-button col-12" [disabled]="!memberSearchForm.valid && !companySearchForm.valid" (click)="search()">
          <mwp-text-translate text="SEARCH" jsonKey="search" />
        </button>
      </div>
      }
    </form>
  </div>
</div>